module.exports = __webpack_public_path__ + "24c3188f36c429fe6c7ac140e40456dd.svg";